import { useRef } from 'react';
import { useGetScreensInfiniteQuery } from './hooks/useGetScreensInfiniteQuery';
import type { AtomicRendererRefCurrent } from './types';
import { Flex, Spinner } from '@banhala/ui-kit';

import { useScrollToFilterList } from './hooks/useScrollToFilterList';
import { useLogViewEvent } from './hooks/useLogViewEvent';
import type { SetState } from 'shared/src/types';
import { useSetTitle } from './hooks/useSetTitle';
import { View, StyleSheet } from 'react-native';
import { AtomicRenderer } from 'shared/src/component';
type ScreensResultProps = {
  setTitle: SetState<string | undefined>;
};

export const ScreensResult = ({ setTitle }: ScreensResultProps) => {
  const atomicRendererRef = useRef<AtomicRendererRefCurrent>(null);
  const { data, fetchNextPage, isFetching, isLoading, refetch } =
    useGetScreensInfiniteQuery();
  useLogViewEvent({ logging: data?.logging, screenName: data?.screenName });
  const { filterListIndex, scrollToFilterList } = useScrollToFilterList({
    atomicRendererRef,
    components: data?.components,
  });
  useSetTitle({ setTitle, title: data?.title });

  if (isLoading) {
    return (
      <Flex.Center flex={1}>
        <Spinner size={20} />
      </Flex.Center>
    );
  }

  if (!data) {
    return null;
  }

  return (
    <>
      {isFetching && (
        <View style={styles.spinnerContainer}>
          <Spinner size={20} />
        </View>
      )}
      <AtomicRenderer
        refetch={refetch}
        data={data}
        fetchNextPage={fetchNextPage}
        listRef={atomicRendererRef}
        filterListIndex={filterListIndex}
        scrollToFilterList={scrollToFilterList}
        isFetching={isFetching}
      />
    </>
  );
};

const styles = StyleSheet.create({
  spinnerContainer: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: [{ translateX: -10 }, { translateY: -10 }],
    zIndex: 1000,
  },
});
